<template>
    <div>
        <b-sidebar v-model="sidebarVisible" id="sidebar-1" backdrop width="340px">
            <template #header="{ hide }">
                <b-button pressed variant="light" @click="hide">
                    <b-icon icon="list"></b-icon>
                </b-button>
                &nbsp;&nbsp;

                <router-link
                    to="/"
                    class="h4 mb-0 text-lg text-uppercase d-none d-lg-inline-block"
                    >OMS</router-link
                >
            </template>
            <template #default>
                <div class="accordion" role="tablist">
                    <b-card
                        no-body
                        class="mb-1"
                        v-for="(x, idx) in linkGroups"
                        :key="x.group"
                    >
                        <b-card-header
                            header-tag="header"
                            class="p-1"
                            role="tab"
                        >
                            <b-button
                                block
                                v-b-toggle="`accordion${idx}`"
                                variant="primary"
                                >{{ x.group | parseLinkName }}</b-button
                            >
                        </b-card-header>
                        <b-collapse
                            :id="`accordion${idx}`"
                            visible
                            accordion="menu-accordion"
                            role="tabpanel"
                        >
                            <b-card-body>
                                <b-list-group>
                                    <b-list-group-item
                                        v-for="(item, index) in x.children"
                                        :key="index"
                                        :to="item.path"
                                    >
                                        <b-icon :icon="item.icon"></b-icon
                                        >&nbsp;&nbsp;&nbsp;&nbsp;
                                        <span>
                                            {{
                                                item.name | parseLinkName
                                            }}</span
                                        ></b-list-group-item
                                    >
                                </b-list-group>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </template>
        </b-sidebar>

        <div>
            <dashboard-navbar
                @toggle-sidebar="sidebarVisible = !sidebarVisible"
            ></dashboard-navbar>

            <!--Header Content -->
            <portal-target name="dashboardStatsCards"> </portal-target>

            <fade-transition :duration="200" origin="center top" mode="out-in">
                <!-- your content here -->
                <router-view></router-view>
            </fade-transition>

            <content-footer />
        </div>
    </div>
</template>
<script>
//npm components
import { capitalCase, sentenceCase } from 'change-case'
import { FadeTransition } from 'vue2-transitions'
//local components
import DashboardNavbar from './DashboardNavbar.vue'
import ContentFooter from './ContentFooter.vue'
//mixins
import layoutMixins from '@/mixins/layoutMixins'

export default {
    components: {
        DashboardNavbar,
        ContentFooter,
        FadeTransition,
    },
    mixins: [layoutMixins],
    data() {
        return {
            sidebarVisible: false,
            adminRouteItems: [],
        }
    },
    filters: {
        parseLinkName(x) {
            return capitalCase(
                sentenceCase(
                    x

                        .replace(/orders/g, 'activities')
                        .replace(/order/g, 'activity')
                )
            )
        },
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
}
</script>
<style lang="scss"></style>
